import React from "react";
import { Facebook, Linkedin } from "lucide-react";
import kratos_logo from '../Assets/imgs/Kratos_logo.png'

const Footer = () => {
  return (
    <footer id="contact" className="bg-gray-800 text-white pt-10 font-poppins">
      <div className="max-w-6xl mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-between gap-8">
          
          {/* Left Section: Company Info */}
          <div className="md:w-1/2">
            <img className="h-20 object-cover" src={kratos_logo} alt="Logo" />
            <h4 className="text-3xl font-semibold mb-1">Kratos Technologies Pvt. Ltd</h4>
            <p className="pb-1">Address: Grashnista Bhawan, Kuleshwor, Kathmandu, Nepal</p>
            <h4 className="text-2xl font-semibold pt-4 mb-2">Contact</h4>
            <p className="py-1">Tel No: 010222222</p>
            <p>
              Mail:{" "}
              <a href="mailto:info@kratos-np.com" className="text-blue-400 hover:underline">
                info@kratos-np.com
              </a>
            </p>

            {/* Social Icons */}
            <div className="flex mt-4 gap-4">
              <a href="https://www.facebook.com/kratostechnologies" target="_blank" rel="noopener noreferrer">
                <Facebook className="w-5 h-5 hover:text-blue-500" />
              </a>
              <a href="https://www.linkedin.com/company/kratos-technologies-pvt-ltd-nepal/" target="_blank" rel="noopener noreferrer">
                <Linkedin className="w-5 h-5 hover:text-blue-300" />
              </a>
            </div>
            
          </div>

          {/* Right Section: Embedded Map */}
          <div className="md:w-1/2 h-74">
            <iframe
              title="Kratos Location"
              className="w-full h-full rounded-lg shadow-md"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d274.51759367569247!2d85.29844775286185!3d27.687904774301067!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39eb19b437079e5d%3A0x76907de9b3faec58!2sKratos%20Technologies%20Pvt%20ltd%20(one%20plus%20service%20centre)!5e0!3m2!1sen!2snp!4v1748073584972!5m2!1sen!2snp"
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </div>

      {/* Footer Note - moved inside the footer and gap removed */}
      <div className="text-center text-gray-400 text-sm bg-black py-4 mt-8">
        Kratos-np.com  &copy; 2025 -  All rights reserved. Designed & Developed by Bibas Bhattarai
      </div>
    </footer>
  );
};

export default Footer;

// import React from "react";
// import { Facebook, Linkedin } from "lucide-react";

// const Footer = () => {
//   return (
//     <div>
//         <footer id="contact" className="bg-gray-800 text-white py-10 font-poppins">
//         <div className="max-w-6xl mx-auto px-4">
//             <div className="flex flex-col md:flex-row justify-between gap-8">

//             {/* Left Section: Company Info */}
//             <div className="md:w-1/2">
//                 <h4 className="text-xl font-bold mb-2">Kratos Technologies Pvt. Ltd</h4>
//                 <p>Address: Grashnista Bhawan, Kuleshwor, Kathmandu, Nepal</p>
//                 <p>Tel No: 010222222</p>
//                 <p>
//                 Mail:{" "}
//                 <a href="mailto:info@kratos-np.com" className="text-blue-400 hover:underline">
//                     info@kratos-np.com
//                 </a>
//                 </p>

//                 {/* Social Icons */}
//                 <div className="flex mt-4 gap-4">
//                 <a href="https://www.facebook.com/kratostechnologies" target="_blank" rel="noopener noreferrer">
//                     <Facebook className="w-5 h-5 hover:text-blue-500" />
//                 </a>
//                 <a href="https://www.linkedin.com/company/kratos-technologies-pvt-ltd-nepal/" target="_blank" rel="noopener noreferrer">
//                     <Linkedin className="w-5 h-5 hover:text-blue-300" />
//                 </a>
//                 </div>
//             </div>

//             {/* Right Section: Embedded Map */}
//             <div className="md:w-1/2 h-64">
//                 <iframe
//                 title="Kratos Location"
//                 className="w-full h-full rounded-lg shadow-md"
//                 src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d274.51759367569247!2d85.29844775286185!3d27.687904774301067!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39eb19b437079e5d%3A0x76907de9b3faec58!2sKratos%20Technologies%20Pvt%20ltd%20(one%20plus%20service%20centre)!5e0!3m2!1sen!2snp!4v1748073584972!5m2!1sen!2snp"
//                 allowFullScreen=""
//                 loading="lazy"
//                 referrerPolicy="no-referrer-when-downgrade"
//                 ></iframe>
//             </div>
//             </div>

//             {/* Footer Note */}
        
//         </div>
//         </footer>
//             <div className="mt-8 text-center text-gray-400 text-sm bg-black py-4 ">
//             &copy; 2025 Kratos-np.com. All rights reserved.
//             </div>
//     </div>
//   );
// };

// export default Footer;

// // import React from "react";
// // import { Facebook, Linkedin } from "lucide-react";

// // const Footer = () => {
// //   return (
// //     <footer id="contact" className="bg-gray-800 text-white py-10">
// //       <div className="max-w-6xl mx-auto px-4">
// //         <div className="flex flex-col md:flex-row justify-between gap-8">

// //           {/* Left Section: Company Info */}
// //           <div className="md:w-1/2">
// //             <h4 className="text-xl font-bold mb-2">Kratos Technologies Pvt. Ltd</h4>
// //             <p>Address: Grashnista Bhawan, Kuleshwor, Kathmandu, Nepal</p>
// //             <p>Tel No: 010222222</p>
// //             <p>
// //               Mail:{" "}
// //               <a href="mailto:info@kratos-np.com" className="text-blue-400 hover:underline">
// //                 info@kratos-np.com
// //               </a>
// //             </p>

// //             {/* Social Icons */}
// //             <div className="flex mt-4 gap-4">
// //               <a href="https://www.facebook.com/kratostechnologies" target="_blank" rel="noopener noreferrer">
// //                 <Facebook className="w-5 h-5 hover:text-blue-500" />
// //               </a>
// //               <a href="https://www.linkedin.com/company/kratos-technologies-pvt-ltd-nepal/" target="_blank" rel="noopener noreferrer">
// //                 <Linkedin className="w-5 h-5 hover:text-blue-300" />
// //               </a>
// //             </div>
// //           </div>

// //           {/* Right Section: Embedded Map */}
// //           <div className="md:w-1/2 h-64">
// //             <iframe
// //               title="Kratos Location"
// //               className="w-full h-full rounded-lg shadow-md"
// //               src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d274.51759367569247!2d85.29844775286185!3d27.687904774301067!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39eb19b437079e5d%3A0x76907de9b3faec58!2sKratos%20Technologies%20Pvt%20ltd%20(one%20plus%20service%20centre)!5e0!3m2!1sen!2snp!4v1748073584972!5m2!1sen!2snp"
// //               allowFullScreen=""
// //               loading="lazy"
// //               referrerPolicy="no-referrer-when-downgrade"
// //             ></iframe>
// //           </div>
// //         </div>

// //         {/* Footer Note */}
// //         <div className="mt-8 text-center text-gray-400 text-sm">
// //           &copy; 2025 Mobile Distributors Co. All rights reserved.
// //         </div>
// //       </div>
// //     </footer>
// //   );
// // };

// // export default Footer;
